/* eslint-disable global-require */
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database';
import { getMessaging } from 'firebase/messaging';
import { getAnalytics, setUserId } from 'firebase/analytics';
import { getRemoteConfig } from 'firebase/remote-config';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const firebaseConfig = ((): Record<string, any> => {
  switch (process.env.REACT_APP_ENV) {
    case 'HOMOLOG':
      return require('./firebase-homolog.json');
    case 'PROD':
      return require('./firebase-prod.json');
    case 'DEV':
    default:
      return require('./firebase-dev.json');
  }
})();

if (!getApps().length) {
  initializeApp(firebaseConfig);
}

export const app = getApp();
export const remoteConfig = getRemoteConfig(app);

remoteConfig.settings = {
  fetchTimeoutMillis: 60000, // 1min
  minimumFetchIntervalMillis: 1200000, // 20min
};

// export const firestore = firebase.firestore();
export const auth = getAuth();
export const analytics = getAnalytics(app);
export const database = getDatabase();
export const storage = getStorage();

export const messaging = getMessaging();
// export const functions = app.functions('southamerica-east1');

auth.onAuthStateChanged(async next => {
  if (next && next.uid) {
    try {
      setUserId(analytics, next.uid);
      await auth.updateCurrentUser(next);
    } catch (error) {
      console.error(error);
    }
  } else {
    setUserId(analytics, null);
  }
});

// functions.useFunctionsEmulator('http://localhost:5001');

auth.languageCode = 'pt-br';
export default app;
